import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder, ArrayDecoder, IntegerDecoder, BooleanDecoder, DateDecoder, EmailDecoder } from '@simonbackx/simple-encoding';
import { Discount } from './Discount.js';
import { v4 as uuidv4 } from 'uuid';
export class DiscountCode extends AutoEncoder {
    static maxPerWebshop = 1000;
    id;
    code;
    description = '';
    discounts = [];
    usageCount = 0;
    maximumUsage = null;
    /**
     * When an order is correctly placed, we store the reserved amount in the stock here.
     * We need this to check the stock changes when an order is edited after placement.
     */
    reserved = false;
    createdAt = new Date();
    updatedAt = new Date();
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], DiscountCode.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], DiscountCode.prototype, "code", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 241 })
], DiscountCode.prototype, "description", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Discount) })
], DiscountCode.prototype, "discounts", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], DiscountCode.prototype, "usageCount", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], DiscountCode.prototype, "maximumUsage", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], DiscountCode.prototype, "reserved", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 240 })
], DiscountCode.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 240 })
], DiscountCode.prototype, "updatedAt", void 0);
/**
 * Dashboard only: the public DiscountCode is returned to shoppers who enter a code.
 */
export class PrivateDiscountCode extends DiscountCode {
    /**
     * Only used to email the code to someone and to match rows on import. Not unique, and not
     * checked against the email of the person placing the order.
     */
    email = null;
}
__decorate([
    field({ decoder: EmailDecoder, nullable: true, version: 421 })
], PrivateDiscountCode.prototype, "email", void 0);
//# sourceMappingURL=DiscountCode.js.map